import { createFileRoute } from "@tanstack/react-router";
import { CustomAppWindowPage } from "src/components/views/customApps/CustomAppWindowPage.tsx";

export const Route = createFileRoute("/customAppWindow/$windowId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { windowId } = Route.useParams();
	return <CustomAppWindowPage windowId={windowId} />;
}
